// import { useFormik } from "formik";
// import {
//   BackButton,
//   CancelButton,
//   SubmitButton,
// } from "../../../../Components/Utils/Buttons";
import { useLocation, useParams } from "react-router-dom";  
import * as yup from "yup";
import useFetchMataData from "../../../../../../Components/Hooks/useFetchMataData";
import UseEditData from "../../../../../../Components/Hooks/useEditData";
import { useEffect, useState } from "react";
import { useFormik } from "formik";
import UseDropDown from "../../../../../../Components/Hooks/useDropDown";
import Breadcrumb from "../../../../../../Components/Utils/Breadcrumb";
import { BackButton, CancelButton, DeleteButton, SubmitButton } from "../../../../../../Components/Utils/Buttons";
import FormikSelectTwo, { SelectProductWithError } from "../../../../../../Components/Utils/Select";
import { NuInput, NuInputWithError, NuTextArea } from "../../../../../../Components/Utils/Input";
import DropDownAddMetaData, { DropDownAddUnitWithError } from "../../../../../../Components/Utils/selectAddMetaData";
import { Select } from "antd";
import EditIcon from "../../../../../../Components/Icons/Edit";
import UseProductDropDownNew from "../../../../../../Components/Hooks/useProductSearch";
import DropDownAddSubCategory from "../../../../../../Components/Utils/selectAddSubCategory";
import DropDownAdd from "../../../../../../Components/Utils/selectAdd";
import UseCatSubCatDropDown from "../../../../../../Components/Hooks/useCategoryDropDown";
import axiosInstance from "../../../../../../Services/axiosCommon";
// import useAddFormData from "../../../../Components/Hooks/useAddFormData";
// import { useEffect, useState } from "react";
// import Input, { NuInput, NuSelect, NuTextArea } from "../../../../Components/Utils/Input";
// import UseEditData from "../../../../Components/Hooks/useEditData";
// import { useLocation, useParams } from "react-router-dom";
// import FormikSelectTwo from "../../../../Components/Utils/Select";
// import axiosInstance from "../../../../Services/axiosCommon";
// import UseDropDown from "../../../../Components/Hooks/useDropDown";
// import Breadcrumb from "../../../../Components/Utils/Breadcrumb";
// import useFetchMataData from "../../../../Components/Hooks/useFetchMataData";
// import DropDownAddMetaData from "../../../../Components/Utils/selectAddMetaData";

const EditRequest = () => {
  const {officeId,projeCtId} =useParams();

  const {value:Unit,getData:refUnit} = useFetchMataData(`/dropdown/dropdown-details/`,'Unit_item')
  const {value:RequestFor} = useFetchMataData(`/dropdown/dropdown-details/`,'RequestFor')
  const {value:PurposeOfRequest} = useFetchMataData(`/dropdown/dropdown-details/`,'PurposeOfRequest')
  const {value:RequestStatus,getData:refRequestStatus} = useFetchMataData(`/dropdown/dropdown-details/`,'RequestStatus')
  // const [loading, setLoading] = useState(false);
  // const {value:Unit} = useFetchMDIndex(`/dropdown/dropdown-details/`,'Unit_item',showFilterDialog)
 const [items, setItems] = useState([]);
  const [remove, setRemove] = useState([]);
  const [isEditQua, setIsEditQua] = useState(false);
  const [isEditUnit, setIsEditUnit] = useState(false);
  const [isEditReturnQua, setisEditReturnQua] = useState(false);

  const [combinedItems, setCombinedItems] = useState([]);
  // console.log(items, "kk");
  // console.log(data, "pp");
  const [newItemData, setNewItemData] = useState({
    productId: "",
    quantity: "",
    product_unit: "",
  });
    const [sortedProList,setSortedProList] =  useState([]);
    const [oldData, setOldData] = useState([])
  const [error, setError] = useState("");
    const [search, setSearch] = useState("");
    const [fileRemoveList, setFileRemoveList] = useState([]);
    const [selectedFile, setSelectedFile] = useState(null);
  
    const [productError, setProductError] = useState("");
    const [unitError, setUnitError] = useState("");
    const [quantityError, setQuantityError] = useState("");
    const { data: Item, setData } = UseProductDropDownNew(
      `/items/new-drop-down/${officeId}/branch`,
      search
    );

    const { value: product_unit, getData: refProUnit } = useFetchMataData(
          `/dropdown/dropdown-details/`,
          "Unit_item"
        );
  const handleAdd = () => {
    let hasError = false;

    if (!formik.values.productId) {
      setProductError("Product is required");
      hasError = true;
    } else {
      setProductError("");
    }

    if (!formik.values.product_unit) {
      setUnitError("Unit is required");
      hasError = true;
    } else {
      setUnitError("");
    }

    if (!formik.values.quantity) {
      setQuantityError("Quantity is required");
      hasError = true;
    } else {
      setQuantityError("");
    }

    if (hasError) return;

    if (formik.values.productId && formik.values.quantity) {
      const selectedProduct = Item.find(
        (i) => i.value === formik.values.productId
      );
      const newItem = {
        productId: formik.values.productId,
        productName: sortedProList.find((i) => i.value === formik.values.productId),
        quantity: formik.values.quantity,
        // unit: selectedProduct.unit,
        product_unit: formik.values.product_unit,
      };
      setItems([...items, newItem]);

      setNewItemData({
        productId: "",
        product_unit: "",
        quantity: "",
      });
      let updatedItems = Item.filter(
        (it) => it.value !== formik.values.productId
      );
      setData(updatedItems);
      formik.values.productId = "";
      formik.values.quantity = "";
      formik.values.product_unit = "";

      setError("");
    }
  };

  const handleQuantityChange = (e, index) => {
    const updatedQuantity = e.target.value;

    const updatedItems = items.map((item, idx) => {
      if (idx === index) {
        return { ...item, quantity: updatedQuantity };
      }
      return item;
    });

    setItems(updatedItems);
  };

  const handleDeleteItem = (indexToDelete) => {
    const updatedItems = items.filter((_, index) => index !== indexToDelete);
    let ddUpdatedItem = items.find((_, i) => i === indexToDelete);
    setItems(updatedItems);
    let tempDd = ddUpdatedItem.productName;
    setData([...Item, tempDd]);
    // localStorage.setItem("items", JSON.stringify(updatedItems));
  };

  const handleReturnQuantityChange = (e, index) => {
    let updatedQuantity = parseInt(e.target.value, 10) || "";
    updatedQuantity = Math.max("", updatedQuantity); 
  
    setItems((prevItems) =>
      prevItems.map((item, idx) =>
        idx === index
          ? {
              ...item,
              returnedQty: updatedQuantity > item.quantity ? item.quantity : updatedQuantity, 
            }
          : item
      )
    );
  };

  const handleReturnQuantityChangeAlredyExit = (e, index) => {
    const updatedItems = [...finalList];
    let updatedQuantity = parseInt(e.target.value, 10) || "";
    updatedQuantity = Math.max("", updatedQuantity); 
  
   
    updatedItems[index].returnedQty =
      updatedQuantity > updatedItems[index].quantity ? updatedItems[index].quantity : updatedQuantity;
  
    setFinalList(updatedItems);
  };


  const { Oncancel, editData, contextHolder, isLoading } = UseEditData();
    const location = useLocation();
    const data = location.state.data;
    const from = location.state.from;

  const [createNew, setCreateNew] = useState({
    requestFor: data?.requestFor || "",
    purpose: data?.purpose || "",
    isReturnable: data?.isReturnable || "",
    productId: data?.productId || "",
    comments: data?.comments || "",
    quantity: data?.quantity || "",
    product_unit: data?.product_unit || "",
    approvedBy: data?.approvedBy || "",
    reviewedBy : data?.reviewedBy || "",
    preparedBy: data?.preparedBy || "",
    issueedBy: data?.issueedBy || "",
    status: data?.status || ""

  });
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: createNew,
    validateOnChange: false,
    validateOnBlur: false,
    validationSchema: yup.object({
      // item: yup.string().required('Product is required!'),
      // quantity: yup.string().required('Quantity is required!'),

    }),
    onSubmit: async (value, { resetForm }) => {
      // setLoading(true)
      if (items.length === 0 && data?.products?.length === 0) {
        setError("Product table is empty");
        return;
      }
      let formData = new FormData();
      const valueWithItems = {
        ...value,
        products: items,
        removedProducts: remove,
        filesToRemove: fileRemoveList,
      };

      formData.append("json_data", JSON.stringify(valueWithItems));
      if (selectedFile !== null) {
        selectedFile.forEach((file) => {
          formData.append("attachments", file);
        });
      } else {
        formData.append("attachments", []);
      }
      editData(`/requests/edit-request/${data.requestId}`, formData, resetForm, from)
      // setLoading(false)

      
    },
    
  });

  const [showPop, setShowPop] = useState(false);

  const togglePop = () => {
    setShowPop(!showPop);
  };
  const { data: user } = UseDropDown('/user/drop-down');
  const { data: itemss } = UseDropDown(`/items/drop-down/${projeCtId}/branch`);
  const [dataa, setDatas] = useState(data);

    const [finalList, setFinalList] = useState(dataa?.products);
  
     const handlePopSubmit = async (e) => {
        e.preventDefault();
    let pName= formik.values.productName
        const formData = new FormData();
        formData.append(
          "json_data",
          JSON.stringify({
            productName: formik.values.productName,
            unit: formik.values.unit,
            category: formik.values.category,
            subCategory: formik.values.subCategory,
            branchId: officeId,
    
          })
        );
    
        try {
          const response = await axiosInstance.post("/items/new-item", formData);
          const createdProduct = response.data?.data;
    console.log(pName,"data");
    
          setData((prevProducts) => [
            {
              label: pName,
              value: createdProduct.id,
              unit: createdProduct.unit,
            }, // Add the new product at the start
            ...prevProducts,
          ]);
    
          resetForm();
        } catch (error) {
          console.error("Error creating new product:", error);
        }
      };
      const {
        category: itemsCategory,
        subCategory: itemsSubCategory,
        getCategory,
        fetchSubCategory,
      } = UseCatSubCatDropDown(
        "/category/ItemCategory",
        "ItemCategory",
        formik?.values?.category
      );
    
      const resetForm = () => {
        formik.values.productName = "";
        formik.values.unit = "";
        formik.values.category = "";
        formik.values.subCategory = "";
        setShowPop(false);
      };

  const handleQuantityChangeAlredyExit = (e, index) => {
    const updatedItems = [...finalList];
    updatedItems[index].quantity = e.target.value;
    setFinalList(updatedItems);
    console.log("shsd", finalList);
  };
  const handleDelete = (productId) => {
    const updatedProducts = dataa?.products.filter(
      (item) => item.productId !== productId
    );
    // const deletedItem = dataa?.productList.find(item => item.productId === productId);
    console.log(updatedProducts, "lll");

    setDatas((prevState) => ({
      ...prevState,
      products: updatedProducts,
    }));
    setRemove([...remove, productId]);

    // setremove(prevState => ({
    //   ...prevState,
    //   removedProducts: [...prevState.removedProducts, deletedItem]
    // }));
  };
  const handleProductUnitChangeAlredyExit = (value, index) => {
    const updatedItems = [...finalList];
    updatedItems[index].product_unit = value?.value;
    setFinalList(updatedItems);
    console.log("shsd", finalList);
  };
   const handleProductUnitChange = (value, index) => {
      const updatedItems = items.map((item, idx) => {
        if (idx === index) {
          return { ...item, product_unit: value?.value };
        }
        return item;
      });
      setItems(updatedItems);
    };
  
  
  
    useEffect(()=>{
      const filterdItem = Item.filter(
        (drop) => !dataa?.products?.some((id) => id.productId === drop.value)
      );
      if(Item){
        const union = Array.from(
          new Map([...filterdItem, ...oldData].map((item) => [item.value, item])).values()
        );
        let data = union.sort((a, b) => a.label.localeCompare(b.label))
        setSortedProList(data)
      }
      console.log("item",Item);
      
    },[Item])
  
    useEffect(() => {
      if (formik.values.productId) {
        const findValue = sortedProList.filter((v) => formik.values?.productId ==(v.value));
        console.log("final",findValue);
        
        setOldData(findValue);
      }
      console.log("Testing",formik.values.productId);
    },[formik.values.productId])



  // useEffect(() => {
  //   if (formik.values.item) {
  //     const selectedProduct = items.find((i) => i.value === formik.values.item);
  //     if (selectedProduct) {
  //       formik.setFieldValue('unit', selectedProduct.unit);
  //     }
  //   }
  // }, [formik.values.item, items]);
  
  return (
    <div className="w-full h-full py-2 px-4 ">
    <div className="flex justify-end ">
    {/* <Breadcrumb
         items={
          [
            { name: "Store",
            // link: `/main/${officeId}/store/requests` 
          }, 
          {
            name: "Request",
            link: `/project/store/request/${officeId}/${projeCtId}`
          },
          {
            name: "Edit Request"
          }]
         }
        /> */}
        <BackButton />
      </div>
      <form onSubmit={formik.handleSubmit}>
        <div className="w-full mx-auto h-[calc(100vh-145px)] bg-white rounded-md overflow-hidden mt-4">
          <div className=" w-full h-full py-4 px-3 flex justify-start content-start flex-wrap  overflow-y-auto">
                     {/* <FormikSelectTwo
                      label="Product"
                      placeholder="Choose"
                      Options={items}
                      formik={formik}
                      name="item"
                      width="w-full md:w-1/2 lg:w-1/3"
                      isRequired={true}
                    />
                     <FormikSelectTwo
                label="Unit"
                placeholder="Choose"
                Options={Unit}
                formik={formik}
                name="unit"
                width="w-full md:w-1/2 lg:w-1/3"
              />
                    <NuInput
                      type="number"
                      label="Quantity"
                      placeholder="Quantity"
                      formik={formik}
                      isRequired={true}
                      name="quantity"
                      width="w-full md:w-1/2 lg:w-1/3"
                    /> */}
          <FormikSelectTwo
              type="text"
              label="Request For"
              placeholder="Choose"
              Options={RequestFor}
              formik={formik}
              name="requestFor"
              width="w-full md:w-1/2 lg:w-1/3"
              FixPosition={false}
                      PortalTarget={false}
            />  
             <FormikSelectTwo
              type="text"
              label="Purpose Of Request"
              placeholder="Choose"
              Options={PurposeOfRequest}
              formik={formik}
              name="purpose"
              width="w-full md:w-1/2 lg:w-1/3"
              FixPosition={false}
                      PortalTarget={false}
            />  
            {/* <FormikSelectTwo
                type="text"
                label="Unit"
                placeholder="Choose"
                Options={Unit}
                formik={formik}
                name="unit"
                width="w-full "
              /> */}
                    <FormikSelectTwo
                      type="text"
                      label="Is Returnable"
                      placeholder="Choose"
                      Options={[
                        { value: true , label: "Yes"},
                        { value: false , label: "No"},
                      ]}
                      formik={formik}
                      name="isReturnable"
                      width="w-full md:w-1/2 lg:w-1/3"
                      FixPosition={false}
                      PortalTarget={false}
                    />
                   
                    <FormikSelectTwo
                      type="text"
                      label="Issued By"
                      placeholder="Choose"
                      Options={user}
                      formik={formik}
                      name="issueedBy"
                      width="w-full md:w-1/2 lg:w-1/3"
                    /> 
                     <DropDownAddMetaData
                label="Status"
                placeholder="Choose"
                Options={RequestStatus}
                formik={formik}
                name="status"
                width="w-full md:w-1/2 lg:w-1/3"
                getFunc={refRequestStatus}
                displayProperty={"Status"}
                propertyName={"RequestStatus"}
              />   
                     {/* <FormikSelectTwo
              type="text"
              label="Status"
              placeholder="Choose"
              Options={RequestStatus}
              formik={formik}
              name="status"
              width="w-full md:w-1/2 lg:w-1/3"
            />                 */}
                    <NuTextArea
                      label="Comments"
                      placeholder="Comments"
                      formik={formik}
                      name="comments"
                      width="w-full md:w-1/2 lg:w-1/3"
                    />     

<div className="w-full mx-auto h-auto bg-white rounded-md overflow-hidden mt-4 ">
            <div className=" w-full h-full flex justify-start content-start flex-wrap  overflow-y-auto mb-4">
              <div className="w-full">
                <p className="pb-2 pt-4 px-4 text-sm font-medium text-[#111537] underline decoration-[#3369ff] decoration-2 underline-offset-4">
                  Requested Items :
                </p>
              </div>
              <div className="w-full px-2 m-2 flex flex-col md:flex-row gap-y-3 md:gap-y-0 justify-start gap-3 border border-solid rounded-lg">
                {/* <SelectProductWithError
                  type="text"
                  label="Product "
                  placeholder="Product "
                  Options={sortedProList}
                  formik={formik}
                  name="productId"
                  width="w-full md:w-1/2 lg:w-[67%]"
                  ErrMessage={productError}
                  px="0"
                  handleClick={() => {}}
                  hasAddButton={false}
                  setSearch={setSearch}
                  FixPosition={false}
                  PortalTarget={false}
                />
                <DropDownAddUnitWithError
                  label="Unit"
                  placeholder="Choose"
                  Options={Unit}
                  formik={formik}
                  name="product_unit"
                  width="w-full md:w-1/2 lg:w-1/4"
                  // getFunc={refUnit}
                  displayProperty={"Add Unit"}
                  propertyName={"Unit_item"}
                  ErrMessage={unitError}
                  hasAddButton={false}
                  FixPosition={false}
                  PortalTarget={false}
                />
                <NuInputWithError
                  label="Quantity"
                  type="number"
                  formik={formik}
                  placeholder="Quantity"
                  name="quantity"
                  width="w-full md:w-1/2 lg:w-1/4 "
                  ErrMessage={quantityError}
                /> */}

<SelectProductWithError
                  type="text"
                  label="Product "
                  placeholder="Product "
                  Options={sortedProList}
                  formik={formik}
                  name="productId"
                  width="w-full md:w-1/2 lg:w-[67%]"
                  ErrMessage={productError}
                  px="0"
                  handleClick={togglePop}
                  setSearch={setSearch}
                  FixPosition={false}
                  PortalTarget={false}
                />
                <DropDownAddUnitWithError
                  label="Unit"
                  placeholder="Choose"
                  Options={Unit}
                  formik={formik}
                  name="product_unit"
                  width="w-full md:w-1/2 lg:w-1/4"
                  getFunc={refUnit}
                  displayProperty={"Add Unit"}
                  propertyName={"Unit_item"}
                  ErrMessage={unitError}
                  FixPosition={false}
                  PortalTarget={false}
                />
                {/* <button
                  onClick={togglePop}
                  type="button"
                  className=" p-3 py-2 mt-9  text-center h-8 cursor-pointer bg-[#048178] border border-solid border-white  text-xs font-medium  text-white  rounded-lg "
                  >
                  
                  +
                </button> */}
                <NuInputWithError
                  label="Quantity"
                  type="number"
                  formik={formik}
                  placeholder="Quantity"
                  name="quantity"
                  width="w-full md:w-1/2 lg:w-1/4 "
                  ErrMessage={quantityError}
                />

                <button
                  onClick={handleAdd}
                  type="button"
                  className=" p-1 mt-10 m-1 text-center h-8 cursor-pointer bg-textColor-main border border-solid border-white  text-xs font-medium  text-white  rounded-lg "
                >
                  Add
                </button>
              </div>
              <div className="w-full bg-white overflow-hidden mt-5">
                {error && (
                  <p className="text-xs font-semibold text-red-500">{error}</p>
                )}
                <div className="w-full py-3  bg-[#048178] flex justify-between rounded-lg px-6">
                  <p className="w-[5%]  text-left  text-white text-xs font-medium">
                    S.No{" "}
                  </p>

                  <p className=" w-[55%] text-left text-white text-xs font-medium">
                    Product
                  </p>
                  <p className=" w-[15%] text-center pl-4 text-white text-xs font-medium flex justify-center">
                    Unit
                    <span
                      className="pl-1 cursor-pointer"
                      onClick={() => {
                        setIsEditUnit((prv) => !prv);
                      }}
                    >
                      {isEditUnit === true && (
                        <EditIcon width={"14"} height={"14"} color="yellow" />
                      )}
                      {isEditUnit === false && (
                        <EditIcon width={"14"} height={"14"} />
                      )}
                    </span>
                  </p>
                  <p className=" w-[20%] text-center text-white text-xs font-medium flex justify-center">
                    Quantity
                    <span
                      className="pl-1 cursor-pointer"
                      onClick={() => {
                        setIsEditQua((prv) => !prv);
                      }}
                    >
                      {isEditQua === true && (
                        <EditIcon width={"14"} height={"14"} color="yellow" />
                      )}
                      {isEditQua === false && (
                        <EditIcon width={"14"} height={"14"} />
                      )}
                    </span>
                  </p>

                  <p className=" w-[20%] text-center text-white text-xs font-medium flex justify-center">
                    Return Quantity
                    <span
                      className="pl-1 cursor-pointer"
                      onClick={() => {
                        setisEditReturnQua((prv) => !prv);
                      }}
                    >
                      {isEditReturnQua === true && (
                        <EditIcon width={"14"} height={"14"} color="yellow" />
                      )}
                      {isEditReturnQua === false && (
                        <EditIcon width={"14"} height={"14"} />
                      )}
                    </span>
                  </p>

                  <p className=" w-[5%] text-right text-white text-xs font-medium">
                    Action
                  </p>
                </div>
                {items?.length > 0 || dataa.products?.length > 0 ? (
                  <div className="h-[calc(100vh-300px)] overflow-y-scroll">
                    {items.map((List, index) => {
                      return (
                        <div
                          key={index}
                          className="w-full py-2 flex justify-between px-6 odd:bg-white even:bg-slate-100"
                        >
                          <p className="w-[5%]  text-left   text-xs font-medium text-[#111537] py-2.5">
                            {index + 1}
                          </p>
                          <p className=" w-[55%] text-left  text-xs font-medium text-[#111537] py-2.5">
                            {List?.productName?.label}
                          </p>
                          <p className=" w-[15%] text-center pl-4  text-xs font-medium text-[#111537]">
                            <Select
                              value={
                                Unit.find(
                                  (item) => item?.value == List?.product_unit
                                ) || List?.product_unit
                              }
                              options={isEditUnit ? Unit : []}
                              className="w-full"
                              onChange={(value) =>
                                handleProductUnitChange(value, index)
                              }
                              disabled={!isEditUnit}
                            />
                          </p>

                          <p className=" w-[20%] text-center  text-xs font-medium text-[#111537] py-2.5">
                            <input
                              type="number"
                              className="w-11/12 mx-auto outline-none text-center"
                              value={List?.quantity || ""}
                              disabled={!isEditQua}
                              onChange={(e) => handleQuantityChange(e, index)}
                            />
                          </p>
                          <p className=" w-[20%] text-center  text-xs font-medium text-[#111537] py-2.5">
                            <input
                              type="number"
                              className="w-11/12 mx-auto outline-none text-center"
                              value={List?.returnedQty || ""}
                              disabled={!isEditReturnQua}
                              onChange={(e) => handleReturnQuantityChange(e, index)}
                            />
                          </p>

                          <div className="w-[5%] text-right py-2.5">
                            <button
                              onClick={() => handleDeleteItem(index)}
                              type="button"
                              className="text-red-500 cursor-pointer  ml-4 border-none"
                            >
                              <DeleteButton color="red" height={4} />
                            </button>
                          </div>
                        </div>
                      );
                    })}
                    {dataa?.products?.map((List, index) => {
                      return (
                        <div
                          key={index}
                          className="w-full py-2 flex justify-between px-6 odd:bg-white even:bg-slate-100"
                        >
                          <p className="w-[5%]  text-left   text-xs font-medium text-[#111537] py-2.5">
                            {index + 1 + items.length}
                          </p>
                          <p className=" w-[55%] text-left  text-xs  font-medium text-[#111537] py-2.5">
                            {List?.product_name}
                          </p>
                          <p className=" w-[15%] text-center pl-4  text-xs font-medium text-[#111537]">
                            <Select
                              value={
                                Unit.find(
                                  (item) => item?.value == List?.unit
                                ) || List?.unit
                              }
                              options={isEditUnit ? Unit : []}
                              className="w-full"
                              onChange={(value) =>
                                handleProductUnitChangeAlredyExit(value, index)
                              }
                              disabled={!isEditUnit}
                            />
                          </p>
                          <p className=" w-[20%] text-center  text-xs font-medium text-[#111537] py-2.5">
                            <input
                              type="number"
                              className="w-11/12 mx-auto outline-none text-center"
                              value={List?.quantity}
                              disabled={!isEditQua}
                              onChange={(e) =>
                                handleQuantityChangeAlredyExit(e, index)
                              }
                            />
                          </p>

                          <p className=" w-[20%] text-center  text-xs font-medium text-[#111537] py-2.5">
                            <input
                              type="number"
                              className="w-11/12 mx-auto outline-none text-center"
                              value={List?.returnedQty}
                              disabled={!isEditReturnQua}
                              onChange={(e) =>
                                handleReturnQuantityChangeAlredyExit(e, index)
                              }
                            />
                          </p>

                          <div className="w-[5%] text-right py-2.5">
                            <button
                              onClick={() => handleDelete(List?.productId)}
                              type="button"
                              className="text-red-500 cursor-pointer  ml-4 border-none"
                            >
                              <DeleteButton color="red" height={4} />
                            </button>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                ) : (
                  <div className="w-full text-center text-[#93949f]">
                    No Items here
                  </div>
                )}

                {/* </div> */}
              </div>
              {/* <div className="w-full hidden md:block mx-auto my-4 mt-8 py-4">
                <div className="md:flex justify-end gap-4">
                  <CancelButton
                    handleClick={() => {
                      Oncancel();
                    }}
                  />
                  <SubmitButton isLoading={isLoading} />
                </div>
              </div> */}
            </div>
          </div>

            <div className="w-full  mx-auto my-4 mt-8 ">
              <div className="flex justify-end item-end float-right mx-auto md:mx-0 gap-2 pb-4 mt-6 md:mr-4">
                <CancelButton handleClick={()=>{Oncancel(-1)}} />
                <SubmitButton isLoading={isLoading}/>
              </div>
            </div>
          </div>
        </div>
      </form>
      {showPop && (
              <div className="fixed top-0 left-0 w-full h-full bg-gray-800 bg-opacity-50 z-[9999] flex justify-center items-center">
                <div className="animate-scale-in w-[60%] max-h-[80vh] bg-white py-2 px-4 rounded-md shadow-lg overflow-y-scroll ">
                  <h2 className="text-lg font-medium text-[14px]">Add Product</h2>
                  <form onSubmit={handlePopSubmit}>
                    <div className="mb-4 flex flex-wrap">
                      <NuInput
                        label="Product Name"
                        type="text"
                        formik={formik}
                        placeholder="Product Name"
                        name="productName"
                        width="w-full"
                        isRequired={true}
                      />
      
                      <DropDownAddMetaData
                        label="Unit"
                        placeholder="Choose"
                        Options={product_unit}
                        formik={formik}
                        name="unit"
                        width="w-full md:w-1/2 lg:w-1/2"
                        getFunc={refProUnit}
                        displayProperty={"Add Unit"}
                        propertyName={"Unit_item"}
                        isRequired={true}
                        FixPosition={true}
                        PortalTarget={false}
                        
                      />
                      <DropDownAdd
                        type="text"
                        label="Category"
                        placeholder="Category"
                        Options={itemsCategory}
                        formik={formik}
                        name="category"
                        width="w-full md:w-1/2 lg:w-1/2"
                        getFunc={getCategory}
                        categoryName={"ItemCategory"}
                        displayProperty={"Add Category"}
                        isRequired={true}
                        FixPosition={true}
                        PortalTarget={false}
                      />
                      <DropDownAddSubCategory
                        type="text"
                        label="Sub-Category"
                        placeholder="Sub-Category"
                        Options={itemsSubCategory}
                        formik={formik}
                        name="subCategory"
                        width="w-full md:w-1/2 lg:w-1/2"
                        getFunc={fetchSubCategory}
                        category={formik?.values?.category}
                        module={"ItemCategory"}
                        displayProperty={"Add Sub-Category"}
                        FixPosition={true}
                        PortalTarget={false}
                      />
      
                    </div>
                    <div className="flex justify-end">
                      <button
                        type="button"
                        onClick={togglePop}
                        className="px-5 py-[9px] cursor-pointer text-xs 2xl:text-sm bg-[#E6F2F2]  hover:bg-gray-300
                        rounded-md flex items-center mr-2 text-textColor-main"
                      >
                        Cancel
                      </button>
                      <button
                        type="submit"
                        className="bg-textColor-main px-5 py-[9px] cursor-pointer outline-none border-none text-white rounded-md text-xs 2xl:text-sm flex items-center"
                      >
                        Add
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            )}
    </div>
  );
};

export default EditRequest;
